import { Div, TableBuilder, Collection, Ref, CollectionView, SimplePaginator } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class PaginetedTable<T> extends Div
{
    private table: TableBuilder<T>;

    constructor(collection: Collection<T> | Array<T>)
    {
        super();

        if (collection instanceof Array)
        {
            collection = new Collection<T>(collection);
        }

        const start = new Ref<number>(0);
        const count = new Ref<number>(5);
        const view = new CollectionView<T>(collection)
            .See(start, count)
            .Refresh();

        this.table = new TableBuilder(view);

        this.Append(
            this.table,
            new Div().TextAlignRight()
                .VisibleWhen(collection.CountRef, v => v > 0, "block")
                .Append(
                    new SimplePaginator(start, count, collection.CountRef, view.FilteredCount)
                )
        );
    }

    public AddColumn(column: string, callback: (item: T) => appendable): this
    {
        this.table.AddColumn(column, callback);
        return this;
    }

    public Build(): this
    {
        this.table.Build();
        return this;
    }
}
